import { BaseBus } from "./BaseBus";
import { CommonFunctions } from "../static/common-functions";
import { DateFunctions } from "../static/date-functions";

export class v_InvoiceCheckListAttachmentBus extends BaseBus
{
    constructor(busObj: v_InvoiceCheckListAttachmentBus = null) {
        super(busObj);
        if (busObj !== null) {
            this.addedDate = DateFunctions.getDate(this.addedDate);
        }
    }
    CID(): any {
        return this.invoiceCheckListAttachmentId;
    }
    setId(id: any) {
        this.invoiceCheckListAttachmentId = id;
    }
    setParentId(id: any) {
        this.customerId = id;
    }
    initialize(data: v_InvoiceCheckListAttachmentBus) {
        super.initialize(data);
        try {
            this.addedDate = CommonFunctions.getDate(data.addedDate);
            this.updateDt = CommonFunctions.getDate(data.updateDt);
        }
        catch {

        }

    }
    setFromForm(data: v_InvoiceCheckListAttachmentBus) {
        super.setFromForm(data);
    }
    setCommon(userId: any, date: Date, companyId: any = null, personId: any = null) {
        if (!CommonFunctions.hasValue(this.insertDt)) {
            this.insertDt = date;
            this.insertUserId = userId;
            this.addedDate = date;
        }
        this.updateDt = date;
        this.updateUserId = userId;
    }
    setNew(userId: any, date: Date, companyId: any = null, personId: any = null) {
        this.addedDate = date;
        this.personId = personId;
    }

    setBeforeSave() {
        this.insertDt = DateFunctions.getDateTimeWithUTCOffset(this.insertDt);
        this.updateDt = DateFunctions.getDateTimeWithUTCOffset(this.updateDt);

        if (DateFunctions.isValidDate(this.addedDate)) {
            this.addedDate = DateFunctions.getDateWithUTCOffset(this.addedDate);
        }
     }
  invoiceCheckListAttachmentId: any;
  addedDate: Date;
  attachmentDesc: string;
  attachmentType: string;
 // isAdded: boolean;
  isImage: boolean;
  isViewable: boolean;
  attachmentName: string;
  attachment: any;
  personName: string;
  customerId: any;
  invoiceCheckListAttachmentDetailId: any;
  personId: any;
  insertDt: Date;
  insertUserId: any;
  updateDt: Date;
  updateUserId: any;
}
